import { render, staticRenderFns } from "./ProductReviewsHeader.vue?vue&type=template&id=1af6929a&"
import script from "./ProductReviewsHeader.vue?vue&type=script&lang=js&"
export * from "./ProductReviewsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports